import {useUserRoleFunctions} from 'shared/hooks/use-user-role-functions';
import {getPrefixedSection} from 'shared/utils';

import {RoleModelSections} from '../form-constants';

export const useDisableFormFields = (
    entityName?: string,
) => {
    const sectionKey = getPrefixedSection(entityName);

    const {hasUserRoleFunction, isLoadingUserFunctions} = useUserRoleFunctions({
        sections: [sectionKey],
    });
    const getDisableFormFields = () => {
        const sectionUrlData = RoleModelSections.find(item => item.section === sectionKey);
        if (sectionUrlData && !isLoadingUserFunctions) {
            const {functionName} = sectionUrlData || {};
            return !hasUserRoleFunction(functionName);
        }
        return false;
    };

    return {
        getDisableFormFields,
    };
};
